const getLocalTimezone = () => {
  const { timeZone: localTimeZone } = Intl.DateTimeFormat().resolvedOptions();
  return localTimeZone;
};

export default getLocalTimezone;
